var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MatchMedia',{scopedSlots:_vm._u([{key:"default",fn:function({ mobile }){return [_vm._t("default",null,{"joinUrl":_vm.joinUrl(mobile)})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }